export default {
  // Main navigation
  goToHome: 'Go to Home',
  home: 'Home',
  aboutUs: 'About Us',
  solutions: 'Solutions',
  training: 'Training',

  // User
  profile: 'Profile',
  logout: 'Logout',
  enter: 'ENTER',

  // Main menu
  organizationalDefinitions: 'Organizational Definitions',
  curricularDefinitions: 'Curricular Definitions',
  curricularProducts: 'Curricular Products',
  createPrograms: 'Create Programs',
  programRegistry: 'Program Registry',

  // Modes and configuration
  editMode: 'Edit mode',
  editForm: 'Edit Form',
  printOrientation: 'Print Orientation',
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  printZoom: 'Print Zoom',

  // Submenu items
  totalList: 'Total List of',
  registry: 'Registry of',

  // Alerts
  exitEditModeWarning: 'You must exit edit mode before printing.',
}
